export default {
  pageTitle: "Ayuda y soporte",
  pageDescription: "Encuentre respuestas o envíe una solicitud de soporte",
  myTickets: "Mis tickets",
  sections: {
    faqTitle: "Preguntas frecuentes",
    faqDescription: "Consulte las respuestas a las preguntas más habituales",
    ticketTitle: "Enviar un ticket de soporte",
    ticketDescription:
      "Describa su problema y nuestro equipo le responderá por correo electrónico",
  },
  needHelp: {
    title: "¿No encontró lo que buscaba?",
    description:
      "Nuestro equipo de soporte está listo para ayudarle. Envíe un ticket y le responderemos lo antes posible.",
    action: "Enviar ticket",
  },
  tabs: {
    faq: "Preguntas frecuentes",
    faqDesc: "Respuestas a preguntas habituales",
    ticket: "Enviar ticket",
    ticketDesc: "Informe de incidencias o solicite ayuda",
  },
  faqSearchPlaceholder: "Buscar en preguntas y respuestas",
  faqAll: "Todas",
  faqNone: "No hay preguntas frecuentes en esta categoría",
  ticketForm: {
    requestTypeLabel: "¿Qué tipo de solicitud es?",
    requestTypeHint: "Seleccione la opción que mejor describa su solicitud",
    priorityLabel: "Prioridad",
    priorityHint: "¿Qué tan urgente es este problema para su negocio?",
    subjectLabel: "Asunto",
    subjectPlaceholder: "Breve descripción del problema",
    messageLabel: "Mensaje",
    messagePlaceholder: "Describa el problema con detalle...",
    attachmentsLabel: "Adjuntos",
    attachmentsHint:
      "Arrastre archivos aquí o haga clic para subirlos (máx. 20 MB cada uno)",
    addFiles: "Añadir archivos",
    submit: "Enviar ticket",
    fileTooLarge: "{{name}} es demasiado grande. El tamaño máximo es {{max}}.",
    fileUnsupported: "{{name}} no es un tipo de archivo compatible.",
    toastSelectCategory: "Seleccione una categoría",
    toastEnterSubject: "Introduzca un asunto",
    toastEnterMessage: "Introduzca un mensaje",
    toastSubmitted: "¡Ticket enviado! Le responderemos pronto.",
    toastSubmitFailed: "No se pudo enviar el ticket. Inténtelo de nuevo.",
    toastAttachmentsFailed:
      "Ticket creado, pero no se pudieron subir los archivos adjuntos. Puede añadirlos desde la página del ticket.",
    categories: {
      problem: "Problema",
      suggestion: "Sugerencia",
      improvement: "Mejora",
      question: "Pregunta",
      billing: "Facturación",
    },
    priorities: {
      critical: "Crítica",
      high: "Alta",
      medium: "Media",
      normal: "Normal",
      low: "Baja",
    },
    respondLine: "Responderemos a {{email}}",
  },
  list: {
    title: "Mis tickets",
    description: "Consulta y gestiona tus solicitudes de soporte",
    backToSupport: "Ayuda y soporte",
    newTicket: "Nuevo ticket",
    createTicket: "Crear ticket",
    searchPlaceholder: "Busca tickets por asunto o número...",
    loadingTickets: "Cargando tickets...",
    loadError: "No se pudieron cargar los tickets",
    noTicketsFound: "No se encontraron tickets",
    tryAdjusting: "Prueba a ajustar tu búsqueda o filtro",
    createFirstHint: "Crea tu primer ticket para recibir ayuda",
    lastActivityShort: "Última: {{when}}",
    replyNeeded: "Respuesta pendiente",
    messageCountPlain: "{{count}}",
    stats: {
      ongoing: "Activos",
      filterLabel: "Estado del ticket",
      total: "Todos",
    },
  },
  adminList: {
    searchPlaceholder: "Busca por número de ticket, asunto o vendedor...",
    filterAny: "Cualquiera",
    priority: "Prioridad",
    category: "Categoría",
    ticketsFound_one: "{{count}} ticket encontrado",
    ticketsFound_other: "{{count}} tickets encontrados",
    loadingTickets: "Cargando tickets...",
    noTicketsFound: "No se encontraron tickets",
    tryAdjusting: "Prueba a ajustar los filtros",
    allCaughtUp: "¡Todo al día!",
    clearFilters: "Limpiar filtros",
  },
  sidebar: {
    seller: "Vendedor",
    unknownSeller: "Vendedor desconocido",
    sendEmail: "Enviar correo",
    openProfile: "Abrir perfil",
    statusAndPriority: "Estado y prioridad",
    status: "Estado",
    priority: "Prioridad",
    details: "Detalles",
    category: "Categoría",
    created: "Creado",
    lastUpdated: "Última actualización",
    resolved: "Resuelto",
    messages: "Mensajes",
    messagesTotal: "{{count}} en total",
    quickActions: "Acciones rápidas",
    markAsResolved: "Marcar como resuelto",
    closeTicket: "Cerrar ticket",
    reopenTicket: "Reabrir ticket",
  },
  adminDetail: {
    loadingTicket: "Cargando ticket...",
    notFound: "Ticket no encontrado",
    backToTickets: "Volver a los tickets",
    ticketDetails: "Detalles del ticket",
    openedOn: "Abierto el {{date}}",
    messagesCount: "{{count}} mensajes",
    replyPlaceholder:
      "Escribe tu respuesta (se enviará un correo al vendedor)...",
    ticketClosed: "Este ticket está cerrado.",
    reopenTicket: "Reabrir ticket",
  },
  messageInput: {
    modeLabel: "Tipo de mensaje",
    defaultPlaceholder: "Escribe tu mensaje...",
    internalNotePlaceholder: "Añade una nota interna...",
    replyToPartner: "Responder al vendedor",
    internalNote: "Nota interna",
    internalNoteWarning:
      "Las notas internas solo son visibles para el staff",
    attach: "Adjuntar",
    fileTooLarge: "{{name}} es demasiado grande. El tamaño máximo es {{max}}.",
    fileUnsupported: "{{name}} no es un tipo de archivo compatible.",
    addNote: "Añadir nota",
    send: "Enviar",
  },
  messageBubble: {
    internalNote: "Nota interna",
    supportTeam: "Equipo de soporte",
    you: "Tú",
    sellerFallback: "Vendedor",
  },
  detail: {
    messageSent: "¡Mensaje enviado!",
    sendMessageError: "No se pudo enviar el mensaje",
    loadingTicket: "Cargando ticket...",
    notFound: "Ticket no encontrado",
    backToTickets: "Volver a los tickets",
    conversationEmpty:
      "Aún no hay mensajes. Inicie la conversación a continuación.",
    messagesCount_one: "{{count}} mensaje",
    messagesCount_other: "{{count}} mensajes",
    messagePlaceholder: "Escriba su mensaje...",
    resolvedTitle: "Este ticket está resuelto",
    resolvedNeedHelp: "¿Necesita más ayuda?",
    openNewTicket: "Abrir un ticket nuevo",
    openedOn: "Abierto el {{date}}",
    replyNeededTitle: "El equipo de soporte ha respondido",
    replyNeededDescription:
      "Lea el último mensaje abajo y envíe su respuesta para mantener el ticket abierto.",
  },
  adminHub: {
    ticketsTab: "Tickets de soporte",
    ticketsDescription: "Gestiona tickets de soporte de partners",
    chatsTab: "Chats de soporte al cliente",
    chatsDescription: "Gestiona chats de soporte al cliente",
  },
  customerSupportChats: {
    searchPlaceholder: "Buscar por contacto…",
    loading: "Cargando chats…",
    loadingChat: "Cargando conversación…",
    empty: "Ningún chat de soporte coincide con este filtro",
    emptyOpen: "No hay chats de soporte abiertos",
    statusFilter: "Estado",
    filterOpen: "Abiertos",
    filterClosed: "Cerrados",
    filterAll: "Todos",
    closedBadge: "Cerrado",
    selectChat: "Selecciona un chat para ver la conversación",
    noMessages: "Aún no hay mensajes",
    guest: "Invitado",
    registeredCustomer: "Cliente registrado",
    replyPlaceholder: "Responder al cliente…",
    chatClosed: "Este chat está cerrado.",
    closeChat: "Cerrar chat",
    closed: "Chat cerrado",
    recentBookings: "Reservas recientes",
    noBookings: "No se encontraron reservas para este contacto",
    lastHandshakeBadge: "Último handshake",
    openBooking: "Abrir",
    amend: "Modificar",
    reopenHandshake: "Reabrir handshake",
    cancelBooking: "Cancelar",
    amendTitle: "Modificar fecha/hora de la reserva",
    visitDateLabel: "Fecha de visita",
    visitTimeLabel: "Hora de visita",
    overrideCapacity: "Ignorar avisos de capacidad/plazo",
    amendConfirm: "Guardar cambio",
    amendSuccess: "Reserva modificada",
    cancelTitle: "Cancelar reserva",
    cancelDescriptionWithDetails:
      "Cancel the booking for {{name}} ({{activity}})? Confirm amount on the booking detail if needed. Refunds start automatically and cannot be undone.",
    refundChoiceLabel: "Política de reembolso",
    refundDefault: "Reembolsar dentro de ventana, si no no reembolsar",
    refundForce: "Reembolsar siempre",
    refundNone: "Nunca reembolsar (liquidar como cumplida si está pagada)",
    cancelConfirm: "Confirmar cancelación",
    cancelSuccess: "Reserva cancelada",
    reopenSuccess: "Handshake reabierto; este chat se cerró",
    reopenConfirmTitle: "¿Reabrir el handshake?",
    reopenConfirmMessage:
      "Se cerrará el chat de soporte y se reabrirá el handshake para que el partner pueda modificar la reserva en el chat.",
    reopenConfirm: "Reabrir handshake",
    cancelForceConfirmTitle: "¿Confirmar cancelación con anulación?",
    cancelForceRefundMessage:
      "Elegiste reembolsar siempre. Esto anula la política de ventana de reembolso y no se puede deshacer desde esta pantalla.",
    cancelForceNoneMessage:
      "Elegiste no reembolsar nunca. Las reservas pagadas pueden liquidarse como cumplidas sin reembolso al cliente.",
  },
} as const;
